
// src/components/Navbar.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import styles from './Navbar.module.css';
import logo from '../assets/enrichify-logo-transparent.png';

function Navbar() {
  const { isAuthenticated } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMobile] = useState(window.innerWidth <= 768);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    setActiveDropdown(null);
  };

  const closeMenu = () => {
    setIsOpen(false);
    setActiveDropdown(null);
  };

  const toggleDropdown = (dropdownName) => {
    if (window.innerWidth <= 768) {
      setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
    }
  };

  const handleDropdownClick = (e, dropdownName) => {
    if (window.innerWidth <= 768) {
      e.preventDefault();
      toggleDropdown(dropdownName);
    }
  };

  return (
    <nav className={styles.navbar}>
      <Link to="/" className={styles.logo} onClick={closeMenu}>
        <img src={logo} alt="Enrichify Logo" className={styles.logoImage} />
      </Link>
      
      <div className={styles.mobileMenuButton} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div className={`${styles.navButtons} ${isOpen ? styles.active : ''}`}>
        {isAuthenticated ? (
          <>
            <Link to="/dashboard" className={styles.navButton} onClick={closeMenu}>Dashboard</Link>
            <div 
              className={`${styles.navButton} ${styles.dropdown}`}
              onClick={(e) => handleDropdownClick(e, 'tools')}
            >
              <span>Tools</span>
              <div className={`${styles.dropdownContent} ${activeDropdown === 'tools' ? styles.active : ''}`}>
                <Link to="/calculators/back-lay" className={styles.dropdownItem} onClick={closeMenu}>Back/Lay</Link>
                <Link to="/calculators/dutching" className={styles.dropdownItem} onClick={closeMenu}>Dutching</Link>
                <Link to="/calculators/expected-value" className={styles.dropdownItem} onClick={closeMenu}>Expected Value</Link>
                <Link to="/calculators/true-odds" className={styles.dropdownItem} onClick={closeMenu}>True Odds</Link>
                <Link to="/calculators/kelly-criterion" className={styles.dropdownItem} onClick={closeMenu}>Kelly Criterion</Link>
              </div>
            </div>
            <Link to="/bookie-database" className={styles.navButton} onClick={closeMenu}>Bookie Database</Link>
            {/* Show "Settings" button inside mobile dropdown */}
            {isMobile && (
              <Link to="/settings" className={styles.navButton} onClick={closeMenu}>
                Settings
              </Link>
            )}
          </>
        ) : (
          <>
            <Link to="/enterprise" className={styles.navButton} onClick={closeMenu}>Enterprise Options</Link>
            <div 
              className={`${styles.navButton} ${styles.dropdown}`}
              onClick={(e) => handleDropdownClick(e, 'bettingBots')}
            >
              <span>Betting Bots</span>
              <div className={`${styles.dropdownContent} ${activeDropdown === 'bettingBots' ? styles.active : ''}`}>
                <Link to="/conversion-wizard" className={styles.dropdownItem} onClick={closeMenu}>Conversion Wizard</Link>
                <Link to="/mug-master" className={styles.dropdownItem} onClick={closeMenu}>Mug Master</Link>
                <Link to="/betslips-tips" className={styles.dropdownItem} onClick={closeMenu}>Betslips & Tips</Link>
              </div>
            </div>
            <div 
              className={`${styles.navButton} ${styles.dropdown}`}
              onClick={(e) => handleDropdownClick(e, 'tools')}
            >
              <span>Tools</span>
              <div className={`${styles.dropdownContent} ${activeDropdown === 'tools' ? styles.active : ''}`}>
                <Link to="/calculators/back-lay" className={styles.dropdownItem} onClick={closeMenu}>Back/Lay</Link>
                <Link to="/calculators/dutching" className={styles.dropdownItem} onClick={closeMenu}>Dutching</Link>
                <Link to="/calculators/expected-value" className={styles.dropdownItem} onClick={closeMenu}>Expected Value</Link>
                <Link to="/calculators/true-odds" className={styles.dropdownItem} onClick={closeMenu}>True Odds</Link>
                <Link to="/calculators/kelly-criterion" className={styles.dropdownItem} onClick={closeMenu}>Kelly Criterion</Link>
              </div>
            </div>
          <Link to="/Login" className={styles.navButton} onClick={closeMenu}>Login</Link>
          <Link to="/Signup" className={styles.navButton} onClick={closeMenu}>Sign Up</Link>
          </>
        )}
      </div>

      {/* Show settings gear icon only on desktop */}
      {isAuthenticated && !isMobile && (
        <Link to="/settings" className={styles.settingsButton}>
          <i className="fas fa-gear"></i>
        </Link>
      )}
    </nav>
  );
}

export default Navbar;
